// Utils
import { createSelector } from 'reselect';
import { getAgentDisplayName } from 'app/modules/agents/utils';

// Components
import { U21Avatar, U21SelectOptionProps } from 'app/shared/u21-ui/components';

export const selectDropdownAgents = (state: RootState) => {
  return state.dropdown.agents || {};
};

export const selectActiveQueueAgentOptions = (
  selectQueue: number | undefined,
) =>
  createSelector([selectDropdownAgents], (agents) =>
    Object.values(agents).reduce((acc: U21SelectOptionProps[], i) => {
      if (
        i.status === 'ACTIVE' &&
        selectQueue &&
        i.accessible_queues.includes(selectQueue)
      ) {
        const name = getAgentDisplayName(i);
        acc.push({
          icon: <U21Avatar name={name} src={i.picture} />,
          text: name,
          value: i.id,
        });
      }
      return acc;
    }, []),
  );
